import { render } from "./Incidents.vue?vue&type=template&id=49fa4352&scoped=true"
import script from "./Incidents.vue?vue&type=script&lang=js"
export * from "./Incidents.vue?vue&type=script&lang=js"

import "./Incidents.vue?vue&type=style&index=0&id=49fa4352&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fa4352"]])

export default __exports__